import React from "react";
import { Link } from "react-router-dom";

import { GROUNDLIGHT_SUPPORT_EMAIL } from "config/constants";

interface HelpMessageProps {
  topic?: string;
  startText?: string;
}

export function HelpMessage ({ topic, startText }: HelpMessageProps) {
  return (
    <>
      {startText} We&apos;re here for you! Email us at{" "}
      <Link to={`mailto:${GROUNDLIGHT_SUPPORT_EMAIL}`} style={{ color: "#006DD9", textDecoration: "underline" }}>
        {GROUNDLIGHT_SUPPORT_EMAIL}
      </Link>{" "}
      {topic}.
    </>
  );
}
